const steps = [
  { n: '01', title: 'Discover', desc: 'Workshops, tech audit, requirement discovery and success metrics.', icon: 'ri-search-eye-line' },
  { n: '02', title: 'Design', desc: 'Architecture, UX, security model and delivery roadmap sign-off.', icon: 'ri-compasses-2-line' },
  { n: '03', title: 'Build', desc: 'Agile squads in India & Armenia ship in 2-week increments.', icon: 'ri-hammer-line' },
  { n: '04', title: 'Operate', desc: '24×7 SRE, security ops and continuous improvement on our data centre.', icon: 'ri-radar-line' },
];

export default function Process() {
  return (
    <section className="relative bg-background-50 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold uppercase tracking-wider">
            <i className="ri-flow-chart"></i>
            How we work
          </div>
          <h4 className="mt-5 font-heading font-bold text-3xl md:text-5xl text-foreground-900 leading-tight">
            <a href="#process" className="hover:text-primary-700 transition-colors cursor-pointer">
              A disciplined delivery model that de-risks every engagement.
            </a>
          </h4>
        </div>

        <div className="mt-14 relative">
          {/* Connector line */}
          <div className="hidden lg:block absolute top-16 left-8 right-8 h-px bg-gradient-to-r from-primary-200 via-accent-300 to-primary-200"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {steps.map((s, idx) => (
              <div key={s.n} className="relative">
                <div className="relative z-10 w-16 h-16 flex items-center justify-center rounded-full bg-background-50 border-2 border-primary-500 text-primary-700 mx-auto lg:mx-0">
                  <i className={`${s.icon} text-2xl`}></i>
                </div>
                <div className="mt-6 text-center lg:text-left">
                  <div className="font-heading text-xs font-bold tracking-widest text-accent-600">STEP {s.n}</div>
                  <h5 className="font-heading font-bold text-xl text-foreground-900 mt-1">{s.title}</h5>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
                </div>
                {idx < steps.length - 1 && (
                  <div className="lg:hidden flex justify-center my-4">
                    <i className="ri-arrow-down-line text-2xl text-primary-300"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}